<template>
  <b-alert show :variant="variantAttribute" v-if="messages && messages.length > 0"
    class="mt-3 text-center">
    <div v-for="m of uniqueMessages" v-bind:key="m.message" class="warning">
      <span v-html="m.message"></span>
    </div>
  </b-alert>
</template>
<script>
export default {
  props: {
    messages: { type: Array, default: () => [] },
    type: { type: String, default: "Error" }
  },
  computed: {
    variantAttribute() {
      if (this.type === "Success") {
        return "success";
      }
      if (this.type === "Warning") {
        return "warning";
      }
      else {
        return "danger";
      }
    },
    uniqueMessages() {
      return Array.from(new Set(this.messages.map(m => m.message))).map(m => ({ message: m}));
    }
  }
}
</script>